<template>
  <div class="iconContainer d-flex justify-content-center align-items-center">
    <b-img :src="icon" fluid class="w-100" />
  </div>
</template>

<script>
export default {
  name: "WebinarIcon",
  props: {
    icon: String,
  },
};
</script>

<style scoped lang="scss">
.iconContainer {
  min-width: 110px;
  height: 110px;
  width: 110px;
  background-color: $color-light;
  border-radius: 50%;

  @media (max-width: 768px) {
    min-width: 64px !important;
    height: 64px !important;
    width: 64px !important;
  }
}
</style>
